import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "flex items-center justify-between mb-6" }
const _hoisted_5 = {
  key: 0,
  class: "text-[18px] gap-3 text-h-neutral-900"
}
const _hoisted_6 = { class: "font-normal" }
const _hoisted_7 = {
  key: 1,
  class: "font-bold text-[18px] gap-3 flex text-h-neutral-900"
}
const _hoisted_8 = { class: "font-normal max-w-[30vw] truncate" }
const _hoisted_9 = { class: "flex h-8 gap-4" }
const _hoisted_10 = { class: "px-0 text-base" }
const _hoisted_11 = { class: "px-0 text-base" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "px-0 text-base"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "text-xs" }
const _hoisted_16 = { class: "flex justify-center gap-7" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("button", {
        class: "flex items-center h-8 gap-3 px-0 mb-6 xl btn-simple",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.backToListDenounces()))
      }, [
        _createVNode(_component_v_icon, {
          name: "co-arrow-left",
          width: "24",
          height: "24"
        }),
        (_ctx.isCommentDenounces())
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t("forum.listDenounces.tableDenounces.buttons.toComments")), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t("forum.listDenounces.tableDenounces.buttons.toTopics")), 1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.isCommentDenounces())
          ? (_openBlock(), _createElementBlock("h6", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.$t("labels.generic", {
              pt: "Autor do comentário: ",
              en: "Comment author: ",
            })) + " ", 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.denounceComments?.comment?.userAuthor?.name), 1)
            ]))
          : (_openBlock(), _createElementBlock("h6", _hoisted_7, [
              _createTextVNode(_toDisplayString(_ctx.$t("labels.generic", {
              pt: "Título do tópico: ",
              en: "Topic title: ",
            })) + " ", 1),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.denounceTopic?.topic ? _ctx.denounceTopic?.topic.title : ""), 1)
            ])),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.selectedDenounces.length > 0)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "gap-2 btn-delete-block !p-2",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDialogDeclineDenounce()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    name: "md-cancel-outlined",
                    scale: "0.8"
                  }),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("labels.generic", { pt: "Dispensar", en: "Decline" })), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.selectedDenounces.length > 0)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                class: "gap-2 btn-primary !p-2",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDialogAcceptDenounce()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    name: "md-taskalt-outlined",
                    scale: "0.8"
                  }),
                  _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("labels.generic", { pt: "Aceitar", en: "Accept" })), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_Button, {
            class: "flex gap-3 items-center btn-outline !px-2",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sendDisplayedItem()))
          }, {
            default: _withCtx(() => [
              _hoisted_12,
              (_ctx.isCommentDenounces())
                ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.$t("labels.generic", { pt: "Ver comentário", en: "See comment" })), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$t("labels.generic", { pt: "Ver tópico", en: "See topic" })), 1))
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("section", null, [
      _createVNode(_component_DataTable, {
        value: _ctx.denounceComments?.denounces ?? _ctx.denounceTopic?.denounces,
        paginator: _ctx.totalOfDenounces() > 10,
        rows: _ctx.size,
        onPage: _ctx.onPaginate,
        first: _ctx.firstIndexToPaginate,
        showGridlines: "",
        class: "custom-datatableForum !shadow-md rounded-md mb-16",
        selection: _ctx.selectedDenounces,
        "onUpdate:selection": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedDenounces) = $event))
      }, {
        paginatorstart: _withCtx(() => [
          _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.formatePaginatorText()), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            class: "table-style",
            field: "id",
            headerClass: "w-[72px] !bg-h-primary-500",
            selectionMode: "multiple"
          }),
          _createVNode(_component_Column, {
            class: "table-style",
            field: "created",
            header: 
            _ctx.$t('forum.listDenounces.tableDenounces.columns.dateOfDenounce')
          ,
            headerClass: "!bg-h-primary-500 w-[200px]"
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("p", null, _toDisplayString(_ctx.formatDate(data.created as string)), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            class: "table-style max-w-[492px] truncate",
            field: "userAuthor",
            header: 
            _ctx.$t('forum.listDenounces.tableDenounces.columns.denounceAuthor')
          ,
            headerClass: "!bg-h-primary-500 w-[492px]"
          }, null, 8, ["header"]),
          _createVNode(_component_Column, {
            class: "table-style",
            field: "description",
            header: _ctx.$t('forum.listDenounces.tableDenounces.columns.description'),
            headerClass: "!bg-h-primary-500 w-[492px]"
          }, null, 8, ["header"]),
          _createVNode(_component_Column, {
            class: "table-style",
            field: "status",
            header: _ctx.$t('forum.listDenounces.tableDenounces.columns.status'),
            headerClass: "!bg-h-primary-500 w-48"
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("p", {
                class: _normalizeClass(["px-1 text-sm rounded-2xl", _ctx.labelDenouncesStyle[data.status]])
              }, _toDisplayString(_ctx.getStatusText(data.status)), 3)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            class: "table-style",
            header: _ctx.$t('forum.listDenounces.tableDenounces.columns.actions'),
            headerClass: "!bg-h-primary-500 w-[126px]"
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("span", _hoisted_16, [
                _withDirectives((_openBlock(), _createElementBlock("button", {
                  onClick: ($event: any) => (_ctx.showDialogDeclineDenounce(data))
                }, [
                  _createVNode(_component_v_icon, {
                    name: "md-cancel-outlined",
                    class: "text-h-error-400",
                    width: "20",
                    height: "20"
                  })
                ], 8, _hoisted_17)), [
                  [
                    _directive_tooltip,
                    _ctx.$t('labels.generic', {
                pt: 'Recusar denúncia',
                en: 'Decline denounce',
              })
                ,
                    void 0,
                    { top: true }
                  ]
                ]),
                _withDirectives((_openBlock(), _createElementBlock("button", {
                  onClick: ($event: any) => (_ctx.showDialogAcceptDenounce(data))
                }, [
                  _createVNode(_component_v_icon, {
                    name: "md-taskalt-outlined",
                    class: "text-h-primary-500",
                    width: "20",
                    height: "20"
                  })
                ], 8, _hoisted_18)), [
                  [
                    _directive_tooltip,
                    _ctx.$t('labels.generic', {
                pt: 'Aceitar denúncia',
                en: 'Accept denounce',
              })
                ,
                    void 0,
                    { top: true }
                  ]
                ])
              ])
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }, 8, ["value", "paginator", "rows", "onPage", "first", "selection"])
    ]),
    _createVNode(_component_ConfirmDialog, {
      group: "denouncing",
      style: { maxWidth: '490px' },
      class: "w-11/12 custom-confirm-dialog"
    })
  ]))
}